<div class="table-pagination" *ngIf="!shouldHideInitialLoadingState">
  <div class="table-pagination-size">
    <div class="table-pagination-size-dropdown">
      <button
        type="button"
        class="table-pagination-size-select"
        [class.open]="isPageSizeOpen"
        aria-label="Entries per page"
        aria-haspopup="listbox"
        [attr.aria-expanded]="isPageSizeOpen"
        (click)="togglePageSizeDropdown($event)"
      >
        <span>{{ limit }}</span>
        <span class="table-pagination-size-arrow" aria-hidden="true"></span>
      </button>

      @if (isPageSizeOpen) {
      <div class="table-pagination-size-panel" role="listbox" aria-label="Entries per page options">
        @for (option of pageSizeOptions; track option) {
        <button
          type="button"
          class="table-pagination-size-option"
          role="option"
          [class.active]="option === limit"
          [attr.aria-selected]="option === limit"
          (click)="selectPageSize(option, $event)"
        >
          {{ option }}
        </button>
        }
      </div>
      }
    </div>
    <span>entries per page</span>
    <small>
      Showing {{ showingStart }} to {{ showingEnd }} of {{ normalizedTotal }} entries
    </small>
  </div>

  <nav class="table-pagination-nav" [attr.aria-label]="ariaLabel">
    <button
      type="button"
      class="table-pagination-button"
      aria-label="First page"
      [disabled]="isFirstPage"
      (click)="goToPage(1)"
    >
      <span aria-hidden="true">&laquo;</span>
    </button>
    <button
      type="button"
      class="table-pagination-button"
      aria-label="Previous page"
      [disabled]="isFirstPage"
      (click)="goToPage(normalizedPage - 1)"
    >
      <span aria-hidden="true">&lsaquo;</span>
    </button>
    <button type="button" class="table-pagination-button active" aria-current="page">
      {{ normalizedPage }}
    </button>
    <button
      type="button"
      class="table-pagination-button"
      aria-label="Next page"
      [disabled]="isLastPage"
      (click)="goToPage(normalizedPage + 1)"
    >
      <span aria-hidden="true">&rsaquo;</span>
    </button>
    <button
      type="button"
      class="table-pagination-button"
      aria-label="Last page"
      [disabled]="isLastPage"
      (click)="goToPage(normalizedTotalPage)"
    >
      <span aria-hidden="true">&raquo;</span>
    </button>
  </nav>
</div>
